import { Sparkles } from 'lucide-react';
import MarkdownContent from '@/components/MarkdownContent';
import MessageFile from '@/components/MessageFile';

/**
 * One message in a thread — shared by the internal chat (ChatPanel.jsx) and the public
 * embed widget (EmbedChat.jsx), which previously carried near-identical copies of this
 * markup and drifted apart.
 *
 * Colours go through the theme tokens rather than fixed greys: the embed widget renders
 * inside a customer's page and the internal chat has a dark mode, and the old
 * `bg-gray-100` / `bg-red-100` bubbles were unreadable in both.
 */
function AssistantBubble({ message, downloadUrl, actions }) {
  return (
    <div className="flex gap-2 max-w-[92%]">
      <div className="w-6 h-6 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center shrink-0 mt-0.5">
        <Sparkles size={13} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="rounded-2xl rounded-tl-md px-3.5 py-2.5 bg-[var(--app-bg)] border border-[var(--app-border)] text-[var(--app-text)]">
          <MarkdownContent content={message.content} />
        </div>
        {message.file && <MessageFile file={message.file} downloadUrl={downloadUrl} />}
        {actions}
      </div>
    </div>
  );
}

export default function MessageBubble({ message, downloadUrl, actions }) {
  if (message.role === 'assistant') {
    return <AssistantBubble message={message} downloadUrl={downloadUrl} actions={actions} />;
  }
  if (message.role === 'error') {
    return (
      <div className="max-w-[92%] rounded-2xl px-3.5 py-2.5 text-sm bg-error-50 text-error-700 border border-error-200">
        {message.content}
      </div>
    );
  }
  return (
    // A file preview needs the width more than the right-hand gutter does.
    <div className={`ml-auto ${message.file?.preview ? 'max-w-[95%]' : 'max-w-[85%]'}`}>
      <div className="rounded-2xl rounded-br-md px-3.5 py-2.5 bg-primary-600 text-white text-sm break-words">
        {message.content}
      </div>
      {message.file && <MessageFile file={message.file} downloadUrl={downloadUrl} />}
    </div>
  );
}
